import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3l0 8.707","key":"svg-0"}],["path",{"d":"M13 7l4 -4l4 4","key":"svg-1"}],["path",{"d":"M7 14l-4 -4l4 -4","key":"svg-2"}],["path",{"d":"M17 21a11 11 0 0 0 -11 -11h-3","key":"svg-3"}]]

const IconArrowRampLeft = createReactComponent('outline', 'arrow-ramp-left', 'ArrowRampLeft', __iconNode);

export default IconArrowRampLeft;